// UI3
import MillionsIcon from 'ui3/MillionsIcon/MillionsIcon';
// Styles
import styles from './ItemAmount.module.scss';

type ItemAmountProps = {
  onChange: (amount: number) => void;
  value: number;
  id?: string;
  maxQuantity: number;
};

const MIN_AMOUNT = 1;

const ItemAmount = ({
  value,
  onChange,
  id = 'amount',
  maxQuantity,
}: ItemAmountProps) => {
  const handleAmountChange = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    const res =
      +value < MIN_AMOUNT
        ? MIN_AMOUNT
        : +value > maxQuantity
        ? maxQuantity
        : +value;

    onChange(res);
  };

  const handleAmountReduceClick = () => {
    const res = +value - 1 < MIN_AMOUNT ? MIN_AMOUNT : +value - 1;

    onChange(res);
  };

  const handleAmountIncreaseClick = () => {
    const res = +value + 1 > maxQuantity ? maxQuantity : +value + 1;

    onChange(res);
  };

  return (
    <div className={styles.root}>
      <div className={styles.inputWrapper}>
        <button
          onClick={handleAmountReduceClick}
          className={styles.button}
          aria-label="reduce amount"
        >
          <MillionsIcon name="minus" className={styles.icon} />
        </button>

        <input
          type="number"
          id={id}
          value={value}
          onChange={handleAmountChange}
          min={MIN_AMOUNT}
          max={maxQuantity}
          className={styles.input}
        />

        <button
          onClick={handleAmountIncreaseClick}
          className={styles.button}
          aria-label="increase amount"
        >
          <MillionsIcon name="plus" className={styles.icon} />
        </button>
      </div>
    </div>
  );
};

export default ItemAmount;
